import config from '../config.json';
import axios from '../utils/axiosInstance';
import React, { useState, useEffect } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link , IconButton, useMediaQuery, useTheme } from '@mui/material';
import registerImg from '../assets/undraw_mobile_payments_re_7udl.svg';
import { Login } from './Login';
import { UploadFile } from '@mui/icons-material'; // Upload icon

export const Register = ({ open, setOpen, setOpenLogin }) => { 
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [file, setFile] = useState(null); // File state for batch registration
    const [data, setData] = useState({
        name: "",
        email: "",
        password: "",
        passwordConf: "",
        school: ""
    });


    const handleClose = () => {
        setOpen(false);
        setFile(null);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({
            ...data,
            [e.target.name]: value
        });
    };
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        
        // 前端驗證
        if (!data.name || !data.email || !data.password || !data.passwordConf || !data.school) {
            alert("請填寫所有必填欄位！");
            return;
        }
        
        if (data.password.length < 6) {
            alert("密碼長度至少需要6個字符！");
            return;
        }
        
        if (data.password !== data.passwordConf) {
            alert("密碼和確認密碼不一致！");
            return;
        }
        
        const userData = {
            name: data.name,
            email: data.email,
            password: data.password,
            passwordConf: data.passwordConf,
            school: data.school,
            studentNumber: null,
            gender: null
        };
        axios
            .post(config.createUser, userData)
            .then((response) => {
                setOpen(false);
                setData({
                    name: "",
                    email: "",
                    password: "",
                    passwordConf: "",
                    school: ""
                })
                alert("註冊成功！");
                // console.log(response.status, response.data);
            })
            .catch((error) => {
                alert(error.response?.data || "註冊失敗，請重試！");
                if (error.response) {
                    // console.log(error.response);
                    // console.log("server responded");
                } else if (error.request) {
                    // console.log("network error");
                } else {
                    // console.log(error);
                }
            });
    };
    const handleBatchSubmit = () => {
        if (!file) {
            alert("請選擇一個 Excel 文件進行批次註冊。");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        axios
            .post(config.batchRegister, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                alert(response.data.message || "批次註冊成功！");
                setFile(null);
                handleClose();
            })
            .catch((error) => {
                alert(error.response?.data?.message || "批次註冊失敗，請確認文件格式。");
                setFile(null);
            });
    };
    return (
      <div>
       <Dialog 
         open={open} 
         onClose={() => setOpen(false)}
         maxWidth="sm"
         fullWidth
         sx={{
           zIndex: 2000,
           '& .MuiDialog-paper': {
             zIndex: 2000,
             margin: { xs: '16px', sm: '32px' },
             maxWidth: { xs: 'calc(100% - 32px)', sm: '600px' },
             maxHeight: { xs: 'calc(100% - 32px)', sm: '90vh' }
           }
         }}
         PaperProps={{
           sx: {
             zIndex: 2000,
             maxHeight: { xs: '90vh', sm: '90vh' },
             overflow: 'auto'
           }
         }}
       >
       <div style={{ textAlign: 'center', padding: '10px' }}>
              <img 
                className='modal-image' 
                src={registerImg} 
                alt="Register Illustration"
                style={{ 
                  width: 'auto', 
                  height: 'auto', 
                  maxWidth: '150px', 
                  maxHeight: '100px',
                  objectFit: 'contain'
                }} 
              />
            </div>
            <DialogTitle sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>註冊帳號</DialogTitle>
            <DialogContent sx={{ 
              padding: { xs: '16px', sm: '24px' },
              '& .MuiTextField-root': {
                marginBottom: { xs: '8px', sm: '16px' }
              }
            }}>
                <TextField
                    autoFocus
                    margin="dense"
                    id="register-name"
                    label={"請填寫您的姓名"}
                    type="text"
                    name='name'
                    value={data.name}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    id="register-email"
                    label={"請填寫信箱（作為登入帳號）"}
                    type="email"
                    name='email'
                    value={data.email}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                    helperText="請使用有效的電子郵件格式，例如：example@email.com"
                />
                <TextField
                    margin="dense"
                    id="register-password"
                    label={"請填寫密碼"}
                    type="password"
                    name='password'
                    value={data.password}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                    helperText="密碼長度至少需要 6 個字符"
                    inputProps={{
                        minLength: 6
                    }}
                />
                <TextField
                    margin="dense"
                    id="register-password-confirm"
                    label={"請填入確認密碼"}
                    type="password"
                    name='passwordConf'
                    value={data.passwordConf}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                    helperText="確認密碼必須與上面的「密碼」完全相同"
                />
                <TextField
                    margin="dense"
                    id="register-school"
                    label={"請填寫目前就讀的學校"}
                    type="text"
                    name='school'
                    value={data.school}
                    fullWidth
                    variant="standard"
                    onChange={handleChange}
                />
                <DialogContentText>
                    已經有帳號了嗎？
                    <Link component="button" underline="none" onClick={() => { setOpen(false); setOpenLogin(true); }}>
                    登入
                </Link>
            </DialogContentText>
                            {/* <DialogContentText>
                    或者選擇 Excel 文件進行批次註冊：
                </DialogContentText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                        <Button
                            variant="outlined"
                            component="label"
                            startIcon={<UploadFile />}
                        >
                            上傳文件
                            <input
                                type="file"
                                hidden
                                accept=".xlsx"
                                onChange={handleFileChange}
                            />
                        </Button>
                        {file && <span>{file.name}</span>}
                    </div> */}
        </DialogContent>
        <DialogActions sx={{ 
          p: { xs: 1.5, sm: 2.5 }, 
          bgcolor: '#f8f9fa', 
          borderTop: '1px solid #e0e0e0',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: '8px', sm: '0' },
          '& .MuiButton-root': {
            width: { xs: '100%', sm: 'auto' },
            minWidth: { xs: '100%', sm: '64px' }
          }
        }}>
            <Button onClick={handleSubmit} variant="contained" fullWidth={isMobile}>註冊</Button>
            {/* <Button onClick={handleBatchSubmit} color="secondary">批次註冊</Button> */}
        </DialogActions>
      </Dialog>
      </div>
    );
}